import i18n from "../../i18n";
import React from "react";

const MASTER_LOGO = "/images/aj-logo-512.png";

export function AJEmblem({ className = "w-16 h-16", title = "AJ's Farm" }) {
    return (
        <img src={MASTER_LOGO} alt={title} className={`aj-master-emblem object-contain ${className}`} width="512" height="512" draggable="false" />
    );
}

export default function AJFarmLogo({ variant = "full", className = "" }) {
    const compact = variant === "compact";
    return (
        <div className={`aj-brand-lockup ${compact ? "aj-brand-lockup--compact" : ""} ${className}`}>
            <AJEmblem className={compact ? "w-16 h-16 shrink-0" : "w-40 h-40 sm:w-48 sm:h-48"} />
            <div className={compact ? "min-w-0" : "text-center"}>
                <div className={compact ? "aj-brand-name text-lg" : "aj-brand-name text-4xl sm:text-5xl"}>{i18n.t("final.de7b27e508f3")}</div>
                {!compact && <div className="aj-brand-rule" />}
                <div className={compact ? "aj-brand-tagline text-[9px]" : "aj-brand-tagline text-xs sm:text-sm"}>{i18n.t("final.5a61e634ec49")} <span>•</span> {i18n.t("final.9b8dfdff736c")} <span>•</span> {i18n.t("final.5e7dbabf8c70")}</div>
            </div>
        </div>
    );
}
